<template>
  <div class="">
    <Card class="">
      <template #title> Musteriler</template>
      <template #content>
        <div class="mt-1 mb-2 mr-3">

 
          <div class="" style="display: flex; justify-content: space-between; align-items: center;">
            <Button icon="pi pi-plus " size="small" label="Yeni" @click="_YeniMusteri()" />
            <div>
              <InputSwitch v-model="Musteri_PasifMi" @change="MusteriDurumDegistir()" class="mr-2"/>
              <Tag :value="Musteri_PasifMi ? 'Pasif' : 'Aktif'" :severity="Musteri_PasifMi ? 'danger' : 'success'"
                class="text-base px-3 py-1 rounded-md" />
            </div>
          </div> 






          
        </div>
        <DataTable v-if="DataTable_render" :columns="columns" :data="MusteriListesi" :detailbutton="true"
          v-on:set-child-data="getDataChild" :deletebutton="false" v-on:delete-child-data="deleteDataChild"
          :editbutton="true" />
      </template>
    </Card>
  </div>
</template>

<script>
import DataTable from "../../DataTable/DataTable.vue";
import GlobalServis from "../../../../../services/GlobalServis";
import { required, helpers } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";

export default {
  setup: () => ({ v$: useVuelidate() }),
  data() {
    return {
      DataTable_render: true,
      MusteriListesi: [],
      columns: [
        { field: "Isim", header: "Musteri İsim" },
      ],
      Musteri_PasifMi: false,
      MusteriAd: null,
      MusteriAciklama: null,
      Musteri_rowid: null,
    };
  },
  methods: {
    getDataChild(getdata_child) {
      this.Musteri_rowid = getdata_child.data.Musteri_rowid;
      this.$router.push({ path: "/Musteri/DuzenleMusteri", query: { MusteriNo: this.Musteri_rowid } });
    },
    _YeniMusteri() {
      this.$router.push({ path: "/Musteri/YeniMusteri" });
    },
    InitServis() {
      if (this.Musteri_PasifMi) {
        GlobalServis.GlobalServis("GET", "GetMusteriTablosu_Pasif", "").then((res) => {
          if (res.status == 200) {
            this.MusteriListesi = res.data;
          } else if (res.status == 400) {
            this.$toast.add({
              severity: "error",
              summary: "Hata",
              detail: "Önemli bir hata meydana geldi",
              life: 3000,
            });
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Hata",
              detail: "Bilinmeyen bir hata meydana geldi",
              life: 3000,
            });
          }
        });
      } else {
        GlobalServis.GlobalServis("GET", "GetMusteriTablosu", "").then((res) => {
          if (res.status == 200) {
            this.MusteriListesi = res.data;
          } else if (res.status == 400) {
            this.$toast.add({
              severity: "error",
              summary: "Hata",
              detail: "Önemli bir hata meydana geldi",
              life: 3000,
            });
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Hata",
              detail: "Bilinmeyen bir hata meydana geldi",
              life: 3000,
            });
          }
        });
      }

    },
    MusteriDurumDegistir() {
      this._Refresh()
    },
    _Refresh() {
      this.DataTable_render = false;
      this.$nextTick(() => {
        this.InitServis();
        this.DataTable_render = true;
      });
    },
  },
  mounted() {
    this.InitServis();
  },
  components: {
    DataTable,
  },
  validations() {
    return {
      MusteriAd: {
        required: helpers.withMessage("Bu alan boş bırakılamaz", required),
      },
      MusteriAciklama: {
        required: helpers.withMessage("Bu alan boş bırakılamaz", required),
      },
    };
  },
};
</script>